<script lang="ts" setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

interface Props {
  pretitle?: string
  title?: string
  body?: string
  image?: Image
  buttons?: Button[]
  titleClass?: string
  theme?: Theme
}
defineProps<Props>()
</script>

<template>
  <div
    class="relative px-4 md:px-6 overflow-hidden gsap-standout py-32 bg-primary-dark text-zinc-50"
  >
    <div
      class="relative z-20 max-w-screen-2xl p-6 mx-auto flex flex-col lg:flex-row items-center justify-between"
    >
      <!-- Text -->
      <section class="w-full  gsap-standout-card body p-6 md:p-10 lg:p-16 ">
        <p
          v-if="pretitle"
          class="pretitle gsap-standout-preheading"
        >
          {{ pretitle }}
        </p>
        <h2
          class="header text-4xl md:text-5xl lg:text-6xl mb-6 text-balance gsap-standout-heading"
          :class="titleClass"
        >
          {{ title }}
        </h2>
        <Markdown
          v-if="body"
          class="gsap-standout-body"
          :md="body"
        />
        <div class="flex flex-wrap gap-3">
          <ButtonGeneral
            v-for="(button, index) in buttons"
            :key="index"
            v-bind="button"
            class="self-start mt-6 md:mt-6 lg:mt-8"
            :theme="theme"
          />
        </div>
      </section>
    </div>
    <!-- Image -->
    <div class="absolute inset-0 opacity-30 z-10">
      <GeneralImage
        v-bind="image"
        class="w-full h-full object-cover"
      />
    </div>
  </div>
</template>
